module.exports = __webpack_public_path__ + "img/24_4.4751a15d.png";